import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskComentsComponent } from './task-coments.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { NgbTooltipModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SimplebarAngularModule } from 'simplebar-angular';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MentionModule } from 'angular-mentions';
import { ModalFilesModule } from 'src/app/shared/modal-files/modal-files.module';

@NgModule({
  declarations: [
    TaskComentsComponent
  ],
  imports: [
    CommonModule,
    WidgetModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    SharedModule,
    SweetAlert2Module,
    PipesModule,
    SimplebarAngularModule,
    ModalFilesModule,
    NgbTooltipModule,
    NgbDropdownModule,
    MentionModule,
  ],
  exports: [
    TaskComentsComponent
  ]
})
export class TaskComentsModule { }
